import React from "react";
import { SubjectsIntroContainer } from "./SubjectsIntro.style";
import SiteSectionHead from "Components/WebsiteTheme/SiteSectionHead";
import { revealProps } from "Components/WebsiteTheme/Reveal";

import { SITE_SUBJECTS } from "Components/WebsiteTheme/site.data";

/** Subjects intro: section heading, two intro paragraphs, and the subject photos that jump to each subject. */
const SubjectsIntro = () => (
	<SubjectsIntroContainer className="sm_section">
		<div className="sm_container">
			<div className="si_grid">
				<SiteSectionHead
					title={
						<>
							Our <span className="sm_accent">Subjects</span>
						</>
					}
					{...revealProps("left")}
				/>
				<div className="si_text" {...revealProps("up", 1)}>
					<p className="sm_lead">
						<strong>At Subjects Master</strong>, we make learning engaging, interactive, and tailored to every student. Our platform covers a wide range of core subjects, including
						Civics, Math, Science, English, Economics, Foreign Language, and History. Each subject combines standards-aligned content with hands-on, gamified activities designed to
						spark curiosity and mastery.
					</p>
					<p className="sm_body">
						Whether your goal is to reinforce tough concepts, prepare for tests, or inspire a love of learning, our customizable lessons and interactive games empower students to
						succeed at their own pace. With Subjects Master, every subject becomes an opportunity to explore, experiment, and excel.
					</p>
				</div>
			</div>

			<ul className="si_logos" aria-label="Jump to a subject">
				{SITE_SUBJECTS.map((item, index) => (
					<li key={item.id} {...revealProps("up", index)}>
						<button
							type="button"
							className="si_logo"
							style={{ "--tone": item.tone }}
							onClick={() => {
								const el = document.getElementById(item.id);
								if (el) el.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<img src={item.image} alt="" width="640" height="626" loading="lazy" />
							<span>{item.title}</span>
						</button>
					</li>
				))}
			</ul>
		</div>
	</SubjectsIntroContainer>
);

export default SubjectsIntro;
